import { createFileRoute } from '@tanstack/react-router';
import { EditorDoPapel } from '@/features/funcoes/componentes/EditorDoPapel';
import { rotaDeTela } from '@/features/permissoes/guardas';

/** Editar um papel: nome, referência e telas do menu numa tela só (spec 005, CA-05 a CA-08). */
export const Route = createFileRoute('/_autenticado/equipe/funcoes/$id')({
  ...rotaDeTela('equipe.funcoes'),
  component: Pagina,
});

function Pagina() {
  const { id } = Route.useParams();
  return <EditorDoPapel key={id} id={id} />;
}
